import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateMissionContacts } from '@store/slice/missionSlice'
import { updateNotification } from '@store/slice/mainSlice'
import { get } from '@util/xhrAPI'
import { useTranslation } from 'react-i18next'
import useDynamicForm from '@hook/useDynamicForm'
import useDeleteButton from '@hook/useDeleteButton'
import { useTheme } from '@table-library/react-table-library/theme'
import { getTheme } from '@table-library/react-table-library/baseline'
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell,
} from "@table-library/react-table-library/table"
import Alert from '@ui/elements/Alert'
import Div from '@ui/layout/Div'
import Buttons from '@ui/elements/Buttons'

const MissionContacts = () => {
  const { missionContacts } = useSelector(state => state.mission)
  const { mission } = useSelector(state => state.main)
  const deleteButton = useDeleteButton()
  const theme = useTheme(getTheme())
  const dispatch = useDispatch()
  const toggleDynamicForm = useDynamicForm()
  const [t] = useTranslation('common')

  const dataMissionContacts = { nodes: [] }
  if (missionContacts) {
    dataMissionContacts.nodes = Object.values(missionContacts)
  }

  const removeMissionContact = contact => {
    const { id, links } = contact
    get(`${import.meta.env.VITE_API_URL}${links.remove}`, response => {
      const { code } = response
      if (code == 200) {
        const missionContact = missionContacts[id]
        const missionContactsList = { ...missionContacts }
        delete missionContactsList[id]
        dispatch(updateMissionContacts({ ...missionContactsList }))
        dispatch(updateNotification({ type: 'is-success', message: t('messages.removed_successfuly', { title: missionContact.fullName }) }))
      } else {
        dispatch(updateNotification({ type: 'is-danger', message: t('messages.error_occured') }))
      }
    })
  }

  useEffect(() => {
    get(`${import.meta.env.VITE_API_URL}/api/missions/${mission.id}/mission-contacts`, response => {
      const { code, missionContacts } = response
      if (code === 200) {
        dispatch(updateMissionContacts(missionContacts))
      }
    })
  }, [])

  return (
    <Div cssClass='mission-contacts-list'>
      <Div cssClass='actions-zone'>
        <Buttons buttons={{
          icon: 'icon-add',
          cssClass: 'is-info is-small',
          callback: () => toggleDynamicForm('missionContact'),
          text: t('actions.add')
        }}
        />
      </Div>
      <h2 className='zone-title'>{t('titles.mission_contacts_list')}</h2>
      {null !== missionContacts && dataMissionContacts.nodes.length
        ? <>
          <Table data={dataMissionContacts} theme={theme}>
            {(tableList) => (
              <>
                <Header>
                  <HeaderRow>
                    <HeaderCell>ID</HeaderCell>
                    <HeaderCell>{t('table.FullName')}</HeaderCell>
                    <HeaderCell>Email</HeaderCell>
                    <HeaderCell>{t('table.CellPhone')}</HeaderCell>
                    <HeaderCell>{t('table.JobTitle')}</HeaderCell>
                    <HeaderCell>Actions</HeaderCell>
                  </HeaderRow>
                </Header>
                <Body>
                  {tableList.map(item =>
                    <Row key={item.id} item={item}>
                      <Cell>{item.id}</Cell>
                      <Cell>{item.fullName}</Cell>
                      <Cell>{item.email}</Cell>
                      <Cell>{item.cellPhone}</Cell>
                      <Cell>{item.jobTitle}</Cell>
                      <Cell className='table-actions'>
                        <Buttons buttons={[
                          {
                            icon: 'icon-create',
                            cssClass: 'is-info is-small',
                            callback: () => toggleDynamicForm('missionContact', null, item)
                          }
                        ]} />
                        {deleteButton(item, item.title, removeMissionContact)}
                      </Cell>
                    </Row>
                  )}
                </Body>
              </>
            )}
          </Table>
        </>
        : <Alert type='is-info' message={t('messages.empty_list')} />
      }
    </Div>
  )
}

export default MissionContacts